<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">方案名称：</div>
          <el-input v-model="page.planName" class="ipt-sty" placeholder="请输入方案名称"></el-input
        ></el-col>
        <el-col :span="8">
          <div class="search-area-div">启用状态：</div>
          <el-select v-model="page.isOpen" placeholder="请选择启用状态" class="ipt-sty">
            <el-option v-for="item in openStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div style="padding: 20px 20px 0 0; text-align: right">
        <el-button size="medium" type="info" @click="search">搜索</el-button>
        <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
      </div>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addPlatform">新增会议方案</el-button>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="方案名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.planName }}</template>
        </el-table-column>

        <el-table-column
          prop="campaignsState"
          label="方案描述"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.planNote || '-' }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" label="展示顺序" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.sort }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="启用状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.isOpen == '1' ? '启用' : '禁用' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="操作时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="100px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editPlatform(scope.row, scope.row.isOpen)"
              >{{ scope.row.isOpen == '1' ? '设为禁用' : '设为启用' }} ｜</a
            >
            <a class="txt-color" @click="editPlatform(scope.row)">编辑 ｜</a>
            <a class="txt-color" style="color: red !important" @click="delVersion(scope.row.guid, scope.row.isOpen)"
              >删除</a
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">方案名称 </span>
          <el-input type="input" :maxlength="20" placeholder="请填写方案名称" v-model="planName"> </el-input>
        </el-form-item>

        <el-form-item label="方案描述">
          <el-input type="textarea" :rows="5" :maxlength="50" placeholder="请填写方案描述" v-model="planNote">
          </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">展示顺序 </span>
          <el-input
            type="number"
            placeholder="请填写展示顺序"
            min="1"
            oninput="value=value.replace(/[^\d]/g,'')"
            v-model="sort"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增方案'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增方案',
      dialogVisible: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        planName: '',
        isOpen: '-1',
      },
      openStateList: [
        { label: '全部', value: '-1' },
        { label: '启用', value: '1' },
        { label: '禁用', value: '0' },
      ],
      planName: '',
      planNote: '',
      sort: '',
      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      self.tableLoading = true;
      let req = {
        pageIndex: 1,
        pageSize: 10,
        planName: this.page.planName,
        isOpen: this.page.isOpen,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/get-list`, req).then((res) => {
        self.tableLoading = false;

        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;

          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        planName: '',
        isOpen: '-1',
      };
      this.getList();
    },
    addPlatform() {
      this.textTitle = '新增方案';
      this.planName = '';
      this.planNote = '';
      this.sort = '';
      this.dialogVisible = true;
    },
    editPlatform(detail, isOpen) {
      this.planName = detail.planName;
      this.sort = detail.sort;
      this.guid = detail.guid;
      this.planNote = detail.planNote;
      if (isOpen == 0 || isOpen == 1) {
        this.updateReqVersion(isOpen);
      } else {
        this.textTitle = '编辑方案';
        this.dialogVisible = true;
      }
      this.$forceUpdate();
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid, isOpen) {
      var self = this;
      if (isOpen == 1) {
        self.$message.error('启用状态不许删除！');
        return;
      }
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.planName) {
        self.$message.error('请输入方案名称');
        return;
      }
      if (!this.sort) {
        self.$message.error('请输入方案展示顺序');
        return;
      }

      var req = {
        planName: this.planName,
        planNote: this.planNote,
        sort: this.sort,
        isOpen: 1,
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion(isOpen) {
      var self = this;
      if (!this.planName) {
        self.$message('请输入方案名称');
        return;
      }
      if (!this.sort) {
        self.$message('请输入方案展示顺序');
        return;
      }

      var req = {
        planName: this.planName,
        planNote: this.planNote,
        sort: this.sort,
        guid: this.guid,
      };
      if (isOpen == 0 || isOpen == 1) {
        req.isOpen = isOpen == 0 ? 1 : 0;
      }

      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('编辑成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>